<template>
  <footer id="site-footer">
    <v-container class="footer-content">
      <div class="footer-top">
        <div class="brand-block">
          <h1>AGH<br>Solar Boat</h1>
          <h2>Team</h2>
        </div>

        <div class="socials">
          <a href="https://www.facebook.com/AGHSolarBoatTeam/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <v-icon>{{ icons.facebook }}</v-icon>
          </a>
          <a href="https://www.instagram.com/aghsolarboat/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <v-icon>{{ icons.instagram }}</v-icon>
          </a>
          <a href="https://www.linkedin.com/company/agh-solar-boat-team/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <v-icon>{{ icons.linkedin }}</v-icon>
          </a>
          <a href="mailto:kontakt@solarboat.agh.edu.pl" aria-label="Email">
            <v-icon>{{ icons.mail }}</v-icon>
          </a>
        </div>
      </div>

      <div class="footer-grid">
        <div class="col col-discover">
          <span class="col-label">{{ $t('footer.discover') }}</span>
          <ul>
            <li>
              <router-link to="/o-nas">
                <span class="link-arrow">→</span>
                <span>{{ $t('footer.about-us') }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/zespol">
                <span class="link-arrow">→</span>
                <span>{{ $t('footer.team') }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/rekrutacja">
                <span class="link-arrow">→</span>
                <span>{{ $t('footer.recruitment') }}</span>
              </router-link>
            </li>
            <li>
              <router-link to="/kontakt">
                <span class="link-arrow">→</span>
                <span>{{ $t('footer.contact') }}</span>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col col-contact">
          <span class="col-label">{{ $t('footer.contact') }}</span>
          <ul>
            <li>
              <a href="mailto:kontakt@solarboat.agh.edu.pl" class="contact-link">kontakt@solarboat.agh.edu.pl</a>
            </li>
            <li>Kawiory 40, budynek D-9, 30-055 Kraków</li>
            <li>{{ $t("footer.additional_contact") }}</li>
          </ul>
        </div>

        <div class="col col-logos">
          <span class="col-label">{{ $t('footer.university') }}</span>
          <div class="agh-logos">
            <img src="@/assets/img/logo/agh_white.webp" alt="AGH" class="logo-agh" />
            <img src="@/assets/img/logo/weip_white.webp" alt="WEIP" class="logo-weip" />
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="copyright">
          <span class="copy-mark">© AGH Solar Boat Team</span>
          <span class="copy-meta">{{ $t('footer.copy_meta') }}</span>
        </div>

        <div class="credits">
          <p class="credits-line">
            <span class="credits-label">{{ $t('footer.maintenance.old') }}:</span>
            <a href="https://www.linkedin.com/in/filip-nawalaniec-a84ba92b7/" target="_blank" rel="noopener noreferrer">Filip Nawalaniec</a>
          </p>
          <p class="credits-line">
            <span class="credits-label">{{ $t('footer.maintenance.new') }}:</span>
            <a href="https://www.linkedin.com/in/karol-rybski-3199822b1/" target="_blank" rel="noopener noreferrer">Karol Rybski</a>,
            <a href="https://www.linkedin.com/in/maciej-sulima-82ab57416/" target="_blank" rel="noopener noreferrer">Maciej Sulima</a>,
            <a href="https://www.linkedin.com/in/jan-zielo/" target="_blank" rel="noopener noreferrer">Jan Zieliński</a>,
            <a href="https://www.linkedin.com/in/jakub-pachut/" target="_blank" rel="noopener noreferrer">Jakub Pachut</a>
          </p>
        </div>
      </div>
    </v-container>
  </footer>
</template>

<script>
import { mdiFacebook, mdiInstagram, mdiLinkedin, mdiEmailOutline } from '@mdi/js'

export default {
  name: "Footer",
  data() {
    return {
      icons: {
        linkedin: mdiLinkedin,
        instagram: mdiInstagram,
        facebook: mdiFacebook,
        mail: mdiEmailOutline
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  #site-footer
    background: #050315
    color: #fff
    padding: 110px 0 50px
    position: relative

    &::before
      content: ''
      position: absolute
      top: 0
      left: 50%
      transform: translateX(-50%)
      width: 80px
      height: 2px
      background: rgba(255, 255, 255, 0.35)

  .footer-top
    display: flex
    justify-content: space-between
    align-items: flex-start
    gap: 40px
    padding-bottom: 60px
    border-bottom: 1px solid rgba(255, 255, 255, 0.12)

  .brand-block
    h1, h2
      font-family: Raleway, sans-serif
      font-weight: 900
      line-height: 0.9
      letter-spacing: -0.045em
      text-transform: uppercase
      color: #fff
      margin: 0
      text-rendering: geometricPrecision

    h1
      font-size: 4.2em

    h2
      font-size: 4.2em
      color: rgba(255, 255, 255, 0.45)

  .socials
    display: flex
    gap: 12px
    margin-top: 12px

    a
      width: 46px
      height: 46px
      border-radius: 50%
      border: 1px solid rgba(255, 255, 255, 0.2)
      display: inline-flex
      align-items: center
      justify-content: center
      color: rgba(255, 255, 255, 0.65)
      transition: all 0.25s ease
      text-decoration: none

      &:hover
        background: #fff
        color: #0a0828
        border-color: #fff
        transform: translateY(-2px)

      .v-icon
        color: inherit !important
        font-size: 20px

  .footer-grid
    display: grid
    grid-template-columns: 1.1fr 1.3fr 1fr
    gap: 60px
    padding: 60px 0
    border-bottom: 1px solid rgba(255, 255, 255, 0.12)

  .col
    .col-label
      display: block
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.74em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.55)
      margin-bottom: 24px

    ul
      list-style: none
      padding: 0
      margin: 0

      li
        font-family: Inter, sans-serif
        font-size: 0.95em
        line-height: 1.7em
        color: rgba(255, 255, 255, 0.85)
        padding: 4px 0

  .col-discover ul li a
    display: inline-flex
    align-items: center
    gap: 12px
    font-family: Raleway, sans-serif
    font-weight: 700
    font-size: 1.05em
    color: #fff
    text-decoration: none
    text-transform: uppercase
    letter-spacing: 0.04em
    padding: 6px 0
    transition: all 0.25s ease

    .link-arrow
      font-family: Raleway, sans-serif
      color: rgba(255, 255, 255, 0.45)
      transition: all 0.25s ease

    &:hover
      color: #fff

      .link-arrow
        color: #fff
        transform: translateX(4px)

  .col-contact ul li
    a
      color: #fff
      text-decoration: none
      transition: opacity 0.25s ease
      font-weight: 600

      &:hover
        opacity: 0.7

  .col-logos
    .agh-logos
      display: flex
      flex-direction: row
      gap: 40px
      align-items: center

      img
        max-height: 56px
        width: auto
        opacity: 0.85
        transition: opacity 0.25s ease

        &:hover
          opacity: 1

      .logo-weip
        max-height: 44px

  .footer-bottom
    display: flex
    justify-content: space-between
    align-items: flex-start
    gap: 60px
    padding-top: 36px
    flex-wrap: wrap

  .copyright
    display: flex
    flex-direction: column
    gap: 6px

    .copy-mark
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.82em
      letter-spacing: 0.04em
      color: rgba(255, 255, 255, 0.85)

    .copy-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.74em
      letter-spacing: 0.18em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.45)

  .credits
    display: flex
    flex-direction: column
    gap: 4px
    text-align: right

    .credits-line
      margin: 0
      font-family: Inter, sans-serif
      font-size: 0.78em
      line-height: 1.6
      color: rgba(255, 255, 255, 0.55)

      .credits-label
        margin-right: 8px
        color: rgba(255, 255, 255, 0.4)

      a
        color: rgba(255, 255, 255, 0.85)
        font-weight: 600
        text-decoration: none
        transition: opacity 0.25s ease

        &:hover
          opacity: 0.7

  @media only screen and (max-width: 1180px)
    .brand-block
      h1, h2
        font-size: 3em

    .footer-grid
      grid-template-columns: 1fr 1fr
      gap: 40px

    .col-logos
      grid-column: span 2

  @media only screen and (max-width: 768px)
    #site-footer
      padding: 70px 0 40px

    .footer-top
      flex-direction: column
      align-items: flex-start
      gap: 28px
      padding-bottom: 40px

    .brand-block
      h1, h2
        font-size: 2.4em

    .footer-grid
      grid-template-columns: 1fr
      gap: 36px
      padding: 40px 0

    .col-logos
      grid-column: span 1

    .footer-bottom
      flex-direction: column
      align-items: flex-start
      gap: 24px

    .credits
      text-align: left
</style>
